import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Icon from '../components/appIcon';

const AdminNavigation = ({ user, isCollapsed = false, onToggleCollapse }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const [openMenus, setOpenMenus] = useState({});

  const navigationItems = [
     {
      label: 'Dashboard',
      path: '/admin-dashboard',
      icon: 'LayoutDashboard',
      tooltip: 'System overview and analytics'
    },
    {
      label: 'Camera Management',
      path: '/camera-management',
      icon: 'Camera',
      tooltip: 'View Camera settings'
    },
    {
      label: 'Employees Management',
      icon: 'Users',
      path: '/employee-management',
      tooltip: 'Manage employee records and access',
    },
    {
      label: 'Stranger',
      path: '/stranger-detection',
      icon: 'UserX',
      tooltip: 'Manage Stranger records and access'
    },
    {
      label: 'Attendance',
      path: '/attendance-records',
      icon: 'CalendarCheck',
      tooltip: 'View attendance overview'
    },
    {
      label: 'Masters',
      icon: 'Settings',
      tooltip: 'Employee settings and configurations',
      subItems: [
        {
          label: 'Department',
          path: '/department',
          icon: 'Building2'
        },
        {
          label: 'Role',
          path: '/role-management',
          icon: 'UserCheck'
        },
        // {
        //   label: 'Employee Settings',
        //   path: '/settings-management',
        //   icon: 'Settings'
        // },
        //  {
        //   label: 'Capture Settings',
        //   path: '/yolo-settings',
        //   icon: 'ScanSearch'
        // },
      /*   {
          label: 'Camera Settings',
          path: '/camera-management',
          icon: 'Camera'
        }, */
        
        // {
        //   label: 'Stats',
        //   path: '/stats',
        //   icon: 'stats'
        // },
      ]
    }
  ];

  const isActivePath = (path) => location?.pathname === path;

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  const handleProfileToggle = () => {
    setIsProfileOpen(!isProfileOpen);
  };

  const handleLogout = () => {
    navigate('/');
  };

  const toggleMenu = (menuLabel) => {
    setOpenMenus(prev => ({
      ...prev,
      [menuLabel]: !prev[menuLabel]
    }));
  };

  const renderMenuItem = (item, isSubItem = false) => {
    const hasSubItems = item.subItems && item.subItems.length > 0;
    const isMenuOpen = openMenus[item.label];
    
    return (
      <div key={item.path || item.label}>
        <Link
          to={item.path || '#'}
          onClick={(e) => {
            if (hasSubItems) {
              e.preventDefault();
              toggleMenu(item.label);
            } else {
              closeMobileMenu();
            }
          }}
          className={`flex items-center space-x-3 px-3 py-2 rounded-md text-sm font-medium enterprise-transition ${
            isActivePath(item.path) 
              ? 'bg-primary text-primary-foreground' 
              : 'text-muted-foreground hover:text-foreground hover:bg-muted'
          } ${isSubItem ? 'ml-6' : ''}`}
          title={isCollapsed ? item.tooltip : ''}
        >
          <Icon name={item.icon} size={20} />
          {!isCollapsed && <span>{item.label}</span>}
          {!isCollapsed && hasSubItems && (
            <Icon 
              name={isMenuOpen ? 'ChevronDown' : 'ChevronRight'} 
              size={16} 
              className="ml-auto"
            />
          )}
        </Link>
        
        {!isCollapsed && hasSubItems && isMenuOpen && (
          <div className="mt-1 space-y-1">
            {item.subItems.map(subItem => renderMenuItem(subItem, true))}
          </div>
        )}
      </div>
    );
  };

  return (
    <>
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-card border-b border-border enterprise-shadow-card">
        <div className="flex items-center justify-between h-16 px-6">
          {/* Logo and Brand */}
          <div className="flex items-center space-x-4">
            <button
              onClick={onToggleCollapse}
              className="hidden lg:flex items-center justify-center w-8 h-8 rounded-md hover:bg-muted enterprise-transition"
              aria-label="Toggle sidebar"
            >
              <Icon name="Menu" size={20} />
            </button>

            <button
              onClick={toggleMobileMenu}
              className="lg:hidden flex items-center justify-center w-8 h-8 rounded-md hover:bg-muted enterprise-transition"
              aria-label="Toggle mobile menu"
            >
              <Icon name="Menu" size={20} />
            </button>

            <Link to="/admin-dashboard" className="flex items-center space-x-3">
              <div className="flex items-center justify-center w-8 h-8 bg-primary rounded-lg">
                <Icon name="Camera" size={20} color="white" />
              </div>
              <div className="flex flex-col">
                <span className="text-lg font-semibold text-foreground">Employees Attendance</span>
                <span className="text-xs text-muted-foreground">Admin Dashboard</span>
              </div>
            </Link>
          </div>

          {/* User Actions */}
          <div className="flex items-center space-x-3">
            <button
              className="flex items-center justify-center w-8 h-8 rounded-md hover:bg-muted enterprise-transition"
              title="Notifications"
            >
              <Icon name="Bell" size={20} />
            </button>

            <div className="relative">
              <button
                onClick={handleProfileToggle}
                className="flex items-center space-x-2 p-1 rounded-md hover:bg-muted transition-colors duration-150 micro-feedback"
              >
                <div className="w-8 h-8 bg-muted rounded-full flex items-center justify-center">
                  <Icon name="User" size={16} className="text-muted-foreground" />
                </div>
                {user && (
                  <div className="hidden sm:flex flex-col items-start">
                    <span className="text-sm font-medium text-foreground">{user?.name || 'Admin User'}</span>
                    <span className="text-xs text-muted-foreground">{user?.role || 'Administrator'}</span>
                  </div>
                )}
                <Icon name="ChevronDown" size={16} className="text-muted-foreground" />
              </button>

              {/* Profile Dropdown */}
              {isProfileOpen && (
                <>
                  <div
                    className="fixed inset-0 z-1000"
                    onClick={() => setIsProfileOpen(false)}
                  />
                  <div className="absolute top-full right-0 mt-1 w-48 bg-popover border border-border rounded-md shadow-lg z-1010">
                    <div className="py-1">
                      <button className="flex items-center space-x-2 w-full px-3 py-2 text-sm text-popover-foreground hover:bg-muted transition-colors duration-150">
                        <Icon name="User" size={16} />
                        <span>Profile</span>
                      </button>
                      <button className="flex items-center space-x-2 w-full px-3 py-2 text-sm text-popover-foreground hover:bg-muted transition-colors duration-150">
                        <Icon name="Settings" size={16} />
                        <span>Settings</span>
                      </button>
                      <div className="border-t border-border my-1" />
                      <button
                        onClick={handleLogout}
                        className="flex items-center space-x-2 w-full px-3 py-2 text-sm text-error hover:bg-muted transition-colors duration-150"
                      >
                        <Icon name="LogOut" size={16} />
                        <span>Sign Out</span>
                      </button>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </header>
      
      {/* Sidebar for Desktop */}
      <aside className={`fixed top-16 left-0 z-40 h-[calc(100vh-4rem)] bg-card border-r border-border enterprise-shadow-card transition-all duration-200 ease-in-out ${isCollapsed ? 'w-16' : 'w-64'} hidden lg:block`}>
        <div className="flex flex-col h-full p-4">
          <nav className="flex-1 space-y-2">
            {navigationItems?.map(item => renderMenuItem(item))}
          </nav>

          {/* System Status */}
          {!isCollapsed && (
            <div className="mt-auto pt-4 border-t border-border">
              <div className="flex items-center space-x-2 px-3 py-2 text-xs text-muted-foreground">
                <div className="w-2 h-2 bg-success rounded-full"></div>
                <span>System Online</span>
              </div>
            </div>
          )}
        </div>
      </aside>
      
      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen && (
        <div className="fixed inset-0 z-50 lg:hidden">
          <div className="fixed inset-0 bg-black/50" onClick={closeMobileMenu}></div>
          <div className="fixed top-0 left-0 w-80 h-full bg-card border-r border-border animate-slide-in-from-left">
            <div className="flex items-center justify-between h-16 px-6 border-b border-border">
              <div className="flex items-center space-x-3">
                <div className="flex items-center justify-center w-8 h-8 bg-primary rounded-lg">
                  <Icon name="Camera" size={20} color="white" />
                </div>
                <div className="flex flex-col">
                  <span className="text-lg font-semibold text-foreground">CCTV Attendance</span>
                  <span className="text-xs text-muted-foreground">Admin Portal</span>
                </div>
              </div>
              <button
                onClick={closeMobileMenu}
                className="flex items-center justify-center w-8 h-8 rounded-md hover:bg-muted enterprise-transition"
              >
                <Icon name="X" size={20} />
              </button>
            </div>

            <nav className="flex flex-col p-4 space-y-2">
              {navigationItems?.map(item => renderMenuItem(item))}
            </nav>

            <div className="absolute bottom-4 left-4 right-4 pt-4 border-t border-border">
              <div className="flex items-center space-x-2 px-4 py-2 text-xs text-muted-foreground">
                <div className="w-2 h-2 bg-success rounded-full"></div>
                <span>System Online</span>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AdminNavigation;